import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { cyberpunkColors } from './theme/cyberpunkTheme';

const Scores = ({ stats }) => {
  const [chipComponents, setChipComponents] = useState([]);

  // Get color based on score - cyberpunk style
  const getScoreColor = (score) => {
    if (score >= 80) return { bg: 'rgba(0, 255, 65, 0.3)', border: cyberpunkColors.neonGreen, text: cyberpunkColors.neonGreen };
    if (score >= 60) return { bg: 'rgba(0, 255, 255, 0.3)', border: cyberpunkColors.neonCyan, text: cyberpunkColors.neonCyan };
    if (score >= 40) return { bg: 'rgba(255, 170, 0, 0.3)', border: cyberpunkColors.warning, text: cyberpunkColors.warning };
    return { bg: 'rgba(255, 0, 255, 0.3)', border: cyberpunkColors.neonMagenta, text: cyberpunkColors.neonMagenta };
  };

  useEffect(() => {
    if (stats?.scores) {
      const chipData = stats.scores.map(scoreObj => {
        const score = Math.round(scoreObj.Score);
        return {
          score: score > 100 ? 100 : score,
          zoneId: scoreObj.ZoneId,
          zoneName: scoreObj.ZoneName,
        };
      });

      const chips = chipData.map((data, index) => {
        const colors = getScoreColor(data.score);
        return (
          <Box key={index} sx={{ m: 0.5 }}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Chip
                label={data.score}
                sx={{
                  backgroundColor: colors.bg,
                  border: `1px solid ${colors.border}`,
                  color: colors.text,
                  fontFamily: '"Orbitron", sans-serif',
                  fontWeight: 600,
                  fontSize: 12,
                  boxShadow: `0 0 8px ${colors.border}40`,
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: cyberpunkColors.textSecondary,
                  fontFamily: '"Rajdhani", sans-serif',
                  fontSize: 10,
                  mt: 0.5,
                }}
              >
                {data.zoneId}
              </Typography>
            </Box>
          </Box>
        );
      });
      setChipComponents(chips);
    }
  }, [stats]);

  return (
    <Card
      sx={{
        background: 'linear-gradient(145deg, #1a1a24, #0d0d14)',
        border: '1px solid rgba(0, 255, 255, 0.2)',
        borderRadius: 2,
        height: '100%',
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography
            sx={{
              fontSize: 11,
              fontFamily: '"Orbitron", sans-serif',
              color: cyberpunkColors.textSecondary,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
            }}
          >
            AZ Spot Scores
          </Typography>
          <Tooltip
            title="Spot savings percentage by availability zone"
            sx={{ color: cyberpunkColors.neonCyan }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 16, color: cyberpunkColors.neonCyan }} />
          </Tooltip>
        </Box>
        <Box display="flex" flexWrap="wrap" justifyContent="center" alignItems="center">
          {chipComponents}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Scores;
